











import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component<Undo>({})
export default class Undo extends Vue {}
